<template>
  <section class="container" id="sponsors" v-if="sponsors && Object.keys(sponsors).length > 0">
    <h1 class="support-us">Podržavaju nas</h1>

    <template v-for="sponsor in sponsors.Gold">
      <Sponsor
        v-bind:sponsor="sponsor"
        v-bind:key="sponsor.id"
        v-if="sponsors.hasOwnProperty('Gold') && sponsors.Gold.length"
      />
    </template>

    <section class="other-container">
      <template v-if="sponsors.hasOwnProperty('Silver') && sponsors.Silver.length">
        <h2 class="silver-title">Srebrni sponzori</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.Silver">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('Bronze') && sponsors.Bronze.length">
        <h2 class="sponsor-category-description">Brončani sponzori</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.Bronze">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('Organizational') && sponsors.Organizational.length">
        <h2 class="sponsor-category-description">Organizacijski partneri</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.Organizational">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('Workshop') && sponsors.Workshop.length">
        <h2 class="sponsor-category-description">Radionice</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.Workshop">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('FoodAndBeverage') && sponsors.FoodAndBeverage.length">
        <h2 class="sponsor-category-description">Hrana i piće</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.FoodAndBeverage">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('PrizeGame') && sponsors.PrizeGame.length">
        <h2 class="sponsor-category-description">Sponzor nagradne igre</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.PrizeGame">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('GeneralMedia') && sponsors.GeneralMedia.length">
        <h2 class="sponsor-category-description">Generalni medijski pokrovitelj</h2>
        <section class="sponsor-category">
          <Sponsor v-bind:sponsor="sponsors.GeneralMedia[0]" />
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('Media') && sponsors.Media.length">
        <h2 class="sponsor-category-description">Medijski pokrovitelji</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.Media">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>

      <template v-if="sponsors.hasOwnProperty('Friend') && sponsors.Friend.length">
        <h2 class="sponsor-category-description">Prijatelji</h2>
        <section class="sponsor-category">
          <template v-for="sponsor in sponsors.Friend">
            <Sponsor v-bind:sponsor="sponsor" v-bind:key="sponsor.id" />
          </template>
        </section>
      </template>
    </section>
  </section>
</template>

<script>
import Sponsor from '@/components/landing-page/Sponsor.vue';
import { throttle } from '@/config';

export default {
  name: 'SponsorList',
  data() {
    return {
      jobListKey: 0,
    };
  },
  components: {
    Sponsor,
  },
  computed: {
    sponsors: function() {
      return this.$store.getters['landing/sponsor'];
    },
    silverAndBronzeJobs: function() {
      return this.$store.getters['landing/silverAndBronzeJobs'];
    },
  },
  methods: {
    refresh: function() {
      this.jobListKey++;
    },
  },
  created() {
    window.addEventListener('resize', throttle(this.refresh, 200));
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.refresh);
  },
};
</script>

<style scoped>
section > h1,
section > h2 {
  color: #001618;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-weight: 800;
  line-height: 44px;
}

section > h1 {
  font-size: 36px;
  margin-bottom: 70px;
}

h2.sponsor-category-description {
  margin-top: 45px;
  margin-bottom: 75px;
  text-align: center;
  font-size: 40px;
  color: #30cec2;
}

h3.sponsor-category-description {
  margin-top: 45px;
  margin-bottom: 75px;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  color: #30cec2;
}

section > h2.silver-title {
  margin-top: 120px;
  margin-bottom: 90px;
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  color: #30cec2;
}

section.other-container {
  width: 100%;
}

section.sponsor-category {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 100px;
  align-items: center;
  justify-content: center;
}

.support-us {
  margin: 100px auto 56px auto;
  font-size: 40px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

#sponsors {
  margin-bottom: 50px;
}

@media screen and (min-width: 900px) {
  section.container {
    display: flex;
    flex-wrap: wrap;
  }

  .support-us {
    font-size: 48px;
    line-height: 65px;
    margin-bottom: 80px;
    font-weight: 800;
  }

  .silver-title {
    margin-top: 160px;
  }
}
</style>
